import { render, staticRenderFns } from "./Criminals.vue?vue&type=template&id=26f6376e&"
import script from "./Criminals.vue?vue&type=script&lang=js&"
export * from "./Criminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports